import { routes } from '~src/routingConfig';

export const isNewPageDesign = (pathname?: string | null): boolean => {
  if (!pathname) {
    return false;
  }

  const newOuterPages = [
    '/signup',
    routes.login,
    routes.forgot_password,
    '/password',
    '/activate',
    routes.accountSuspended,
  ];
  return newOuterPages.includes(pathname);
};
